export const CURRENCY = "Rs.";
export const LOADING_MESSAGE = "Processing...";

export const GET_CATEGORIES_REQUEST = "GET_CATEGORIES_REQUEST";
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";
export const GET_CATEGORIES_FAILURE = "GET_CATEGORIES_FAILURE";

export const GET_PRODUCTS_REQUEST = "GET_PRODUCTS_REQUEST";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
export const GET_PRODUCTS_FAILURE = "GET_PRODUCTS_FAILURE";

export const GET_TOPPINGS_REQUEST = "GET_TOPPINGS_REQUEST";
export const GET_TOPPINGS_SUCCESS = "GET_TOPPINGS_SUCCESS";
export const GET_TOPPINGS_FAILURE = "GET_TOPPINGS_FAILURE";

export const ADD_TO_CART_REQUEST = "ADD_TO_CART_REQUEST";
export const ADD_TO_CART_SUCCESS = "ADD_TO_CART_SUCCESS";
export const ADD_TO_CART_FAILURE = "ADD_TO_CART_FAILURE";

export const SET_CART_REQUEST = "SET_CART_REQUEST";
export const SET_CART_SUCCESS = "SET_CART_SUCCESS";
export const SET_CART_FAILURE = "SET_CART_FAILURE";

export const REMOVE_FROM_CART_REQUEST = "REMOVE_FROM_CART_REQUEST";
export const REMOVE_FROM_CART_SUCCESS = "REMOVE_FROM_CART_SUCCESS";
export const REMOVE_FROM_CART_FAILURE = "REMOVE_FROM_CART_FAILURE";

export const CHANGE_PRODUCT_COUNT = "CHANGE_PRODUCT_COUNT";

export const MAX_DESCRIPTION_CHARS = 100;

export const NODE_API_URL = "https://gofoodie-mk.herokuapp.com";
export const STRAPI_API_URL = "https://gofoodie-strapi.herokuapp.com";
